import React, { useState } from 'react';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Sidebar from '../../components/Sidebar/Sidebar';

import '../../scss/Form.scss';
import LogInSub from '../LogIn/LoginSub';
import SignupSub from '../SignUp/SignupSub';

const tabsContainerStyles = {
  borderColor: 'divider',
  width: '100%',
} as const;

const TabPanel: React.FC<{
  children: React.ReactNode;
  value: number;
  index: number;
}> = React.memo(({ children, value, index }) => (
  <Box
    sx={{
      width: '100%',
      paddingTop: 0, // Remove any top padding
      marginTop: 0,  // Remove any top margin
    }}
    role="tabpanel"
    hidden={value !== index}
  >
    {value === index && children}
  </Box>
));

export default function MyAccount() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <header>
        <Navbar currentPage="myaccount" />
      </header>
      <main className="main-container" style={{ paddingTop: 0 }}>
        <section className="quiz-signup">
          <Box sx={{ padding: 0 }}>
            <Grid container spacing={2}>
              <Grid
                item
                lg={5}
                xs={12}
                sm={12}
                sx={{ paddingLeft: 0 }}
                className="sidebar-top-spacing"
              >
                <Sidebar />
              </Grid>
              <Grid item xs={12} sm={12} lg={7} xl={6}>
                <Box className="form-container" sx={{ 
                  paddingLeft: { xl: 5, lg: 3 }, 
                  marginTop: 4,
                  paddingTop: 0,
                }}>
                  <Box sx={{ width: '100%', margin: 0, padding: 0 }}>
                    <Box sx={tabsContainerStyles}>
                      <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        sx={{
                          minHeight: 'auto',
                          height: 'auto',
                          marginBottom: 2,
                          '& .MuiTabs-flexContainer': {
                            minHeight: 'auto',
                          },
                          '& .MuiTab-root': {
                            minHeight: 'auto',
                            height: 'auto',
                            padding: '12px 16px',
                            color: '#5E5E5E',
                            fontSize: '16px',
                            textTransform: 'none',
                            '&:hover': {
                              color: '#2A9235'
                            },
                            '&.Mui-selected': {
                              backgroundColor: '#2A9235',
                              color: '#FFFFFF',
                              borderRadius: '4px'
                            }
                          },
                          '& .MuiTabs-indicator': {
                            display: 'none'
                          }
                        }}
                      >
                        <Tab label="Login" sx={{ width: '50%' }} />
                        <Tab label="Sign Up" sx={{ width: '50%' }} />
                      </Tabs>
                    </Box>

                    <Box sx={{ marginTop: 2, paddingTop: 0 }}>
                      <TabPanel value={activeTab} index={0}>
                        <LogInSub isSubComponent={true} />
                      </TabPanel>

                      <TabPanel value={activeTab} index={1}>
                        <SignupSub isSubComponent={true} />
                      </TabPanel>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </section>
      </main>
      <Footer />
    </>
  );
}